import * as Yup from 'yup';

export const ReanaliseNegativaValidation = Yup.object({
  observacao: Yup.string().required('Campo obrigatório'),
  numSolicitacao: Yup.string().required('Campo obrigatório')
});